/**
 * Animation mode for loading indicators throughout the app.
 *
 *   "live"      – Default. Bouncing dots, MUI spinners, shimmer text, blink cursor.
 *                 Best for live demos where natural motion looks good.
 *
 *   "recording" – Subtle opacity pulse + harvey-ball style indicators.
 *                 Won't strobe or look glitchy when video is sped up.
 *
 *   "hidden"    – All loading indicators are invisible.
 *                 Useful for polished screen-recordings where you edit out wait time.
 */
const ANIMATION_MODE = 'hidden'; // 'live' | 'recording' | 'hidden'

export default ANIMATION_MODE;
